<script setup lang="ts">
// 引入 css
import '@wangeditor/editor/dist/css/style.css'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import { DomEditor } from '@wangeditor/editor'
import { contentRemoveTags } from '@qctsw/utils'
import { editorComponent } from '../hooks/editor'

const props = defineProps({
  modelValue: {
    type: String,
    default: '',
  },
})
const emits = defineEmits(['update:modelValue'])
// 编辑器实例，必须用 shallowRef
const editorRef = shallowRef()
const mode = 'default'
// 内容 HTML
const valueHtml = ref(props.modelValue)
const contentCount = computed(() => {
  return contentRemoveTags(valueHtml.value)?.length
})
watch(() => props.modelValue, () => {
  if (props.modelValue !== valueHtml.value) {
    setTimeout(() => {
      valueHtml.value = props.modelValue
    }, 10)
  }
})

const {
  toolbarConfig,
  editorConfig,
  customPaste,
} = editorComponent()

// 组件销毁时，也及时销毁编辑器
onBeforeUnmount(() => {
  const editor = editorRef.value
  if (editor == null)
    return
  editor.destroy()
})

function handleCreated(editor: any) {
  editorRef.value = editor // 记录 editor 实例，重要！

  // setTimeout(() => {
  //   const toolbar = DomEditor.getToolbar(editor)
  // }, 100)
}
function handleChange(_editor: any) {
  // console.log('change:', getContent())
  emits('update:modelValue', getContent())
}

function setDefaultContent(content: string) {
  setTimeout(() => {
    valueHtml.value = content
  }, 10)
}
function getContent() {
  let content = ''
  content = editorRef.value.getHtml()
  return content
}

function getContentText() {
  const text = editorRef.value.getText() || ''
  // console.log('🚀 ~ getContentText ~ text:', text)
  return text
}

defineExpose({
  setDefaultContent,
  getContent,
  getContentText,
})
</script>

<template>
  <div class="border-1 border-slate-3 scroll">
    <Toolbar style="border-bottom: 1px solid #ccc" :editor="editorRef" :default-config="toolbarConfig" :mode="mode" />
    <div>
      <slot />
    </div>
    <Editor
      v-model="valueHtml" style="height: 350px; overflow-y: hidden;" :default-config="editorConfig" :mode="mode"
      @on-created="handleCreated" @on-change="handleChange" @custom-paste="customPaste"
    />
    <div class="text-slate-4 text-3.25 text-right px-2 pb-2">
      <span class="mr-2.5">当前字符数 {{ contentCount }}</span>
      <span>(投诉内容字符数不能少于50)</span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
:deep(.w-e-text-placeholder) {
  top: 8px;
}

*::-webkit-scrollbar {
  width: 3px;
}
</style>
